export default __webpack_public_path__ + "content/media/11.cf81a54f.jpg";